const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-sign-in'] = {
        c: () => require('partner/modules/ext-sign-in/ext-sign-in.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-sign-in',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-sign-in'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-sign-in|ext-sign-in'] = {
                c: () => require('partner/modules/ext-sign-in/ext-sign-in.view.tsx'),
                cn: '__local__-__local__-ext-sign-in'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };